import React, { useState, useEffect } from "react";

import { Button } from "primereact/button";
import AddEditForm from "./components/add-edit-form";
import { useTranslation } from "react-i18next";
import CommonPanel from "../../common/common-panel";
import getCustomerList from "../../../services/customer/customer.service";
import SitesService from "../../../services/AuraCamera/sites/sites.service";
import { useParams, useNavigate, Navigate } from "react-router-dom";
const SitesCreation = () => {
  const [CustomerList, setSitesCustomerList] = useState<any>([]);
  const [allSitesData, setAllSitesData] = useState<any>([]);
  const { t } = useTranslation();

  var navigate = useNavigate();
  useEffect(() => {
    getCustomerList.getCustomerList().then((customer_data_result: any) => {

      if (customer_data_result?.length > 0) {
        //Find index of specific object using findIndex method.
        let objIndex = customer_data_result?.findIndex(((obj: any) => obj?.name == "All"));

        if (objIndex != '-1') {
          //Update object's name property.
          customer_data_result[objIndex].name = "Select Customers"
        } else {
          customer_data_result.unshift({
            "_id": "000000000000000000000000",
            "customerID": "",
            "name": "Select Customers",
            "status": "true",
            "isUom": null,
            "unit": null,
            "preferredEmailDomains": null
          })
        }
      }
      setSitesCustomerList(customer_data_result);
    });
    SitesService.SitesTableApiData().then((all_sites_data: any) => {
      setAllSitesData(all_sites_data);
    });
  }, []);
  return (
    <>
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a onClick={()=>{navigate('/aura-camera/sites')}}>{t("SitesText")}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>{t("SitesCreation.PageHeading")}</a>
          </li>
        </ol>
      </nav>
      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h4 className="page-heading">{t("SitesCreation.PageHeading")}</h4>
            </div>
          </div>
        </div>
      </div>
      <div className="content__boxed dashboard_aogi_content_box_first">
        <div className="content__wrap">
          <div className="card form_wrapper card-mt">
            <CommonPanel
              InnerComponent={
                <AddEditForm
                  CustomerList={CustomerList}
                  AllSitesData={allSitesData}
                />
              }
              Heading={`${t("SitesCreation.FormHeading")}`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SitesCreation;
